import React, {useState} from 'react';

import {InfoIcon} from '@/components/Icons';
import {InlineNotification} from '@/components/ui/InlineNotification';
import * as localizationKeys from '@/consts/localization/localizationKeys';
import {CLOSE_BUTTON_ARIA_LABEL} from '@/consts/localization/localizationKeys';
import {getAriaLabel} from '@/services/accessibilityService';
import {getLocalizedStrings} from '@/services/localization/localizationService';
import storageService from '@/services/storage/storageService';

const MissingDeviceNotification = ({className}) => {
    const dataFromStorage = storageService.getMissingDeviceNotificationDataFromLocalStorage();
    const wasNotificationClosedBefore = !!dataFromStorage;
    const [isVisible, setIsVisible] = useState(!wasNotificationClosedBefore);

    if (!isVisible) return;
    const localizedStrings = getLocalizedStrings();

    const onCloseClick = () => {
        setIsVisible(false);
        storageService.setMissingDeviceNotificationDataToLocalStorage(true);
    };

    return (
        <InlineNotification
            icon={<InfoIcon />}
            title={localizedStrings[localizationKeys.MY_DEVICES_LIST_MISSING_DEVICE_TITLE]}
            body={localizedStrings[localizationKeys.MY_DEVICES_LIST_MISSING_DEVICE_DESCRIPTION_TEXT]}
            onClose={onCloseClick}
            closeButtonProps={{
                'aria-label': getAriaLabel(CLOSE_BUTTON_ARIA_LABEL),
            }}
        />
    );
};

export default MissingDeviceNotification;
